import { nextTick, watch, type ComputedRef, type Ref } from 'vue'

export function useTextareaAutosize(
  elRef: Ref<HTMLTextAreaElement | null>,
  textRef: ComputedRef<string | undefined>,
  isOneLine: ComputedRef<boolean>,
  selectedIdRef: Ref<string>
) {
  function autosize(el: HTMLTextAreaElement | null) {
    if (!el) return

    if (isOneLine.value) {
      el.style.overflowY = 'hidden'
      el.style.height = '40px'
      return
    }

    const max = 180
    el.style.height = '0px'
    const next = Math.min(el.scrollHeight, max)
    el.style.height = next + 'px'
    el.style.overflowY = el.scrollHeight > max ? 'auto' : 'hidden'
  }

  watch(selectedIdRef, async () => {
    await nextTick()
    autosize(elRef.value)
  })

  watch(textRef, async () => {
    await nextTick()
    autosize(elRef.value)
  })

  watch(isOneLine, async () => {
    await nextTick()
    autosize(elRef.value)
  })
}
